<template>
  <runtime-template :template="template"></runtime-template>
</template>

<script>
import RuntimeTemplate from 'v-runtime-template';

export default {
  components: {
    RuntimeTemplate,
  },
  props: {
    tag: {
      default: 'div',
    },
    html: {
      default: '',
    },
  },
  methods: {
    isInternalLink(href) {
      // Check if it's an internal link (starts with '/' and not an external resource)
      return href && href.startsWith('/') && !href.match(/^(https?:|mailto:|tel:|ftp:)/);
    }
  },
  computed: {
    template() {
      return `<component is="${this.tag}">${this.processedHtml}</component>`;
    },
    processedHtml() {
      return this.html.replace(/<a.*?href=(["'])(.*?)\1(.*?)>(.*?)<\/a>/g, (match, quote, href, attrs, text) => {
        // Process external links
        if (/^http/.test(href)) {
          let url;
          try {
            url = new URL(href);
            if (url.host !== window.location.host) {
              return match;
            }
          } catch {
            return match;
          }

          href = url.pathname + url.search + url.hash;
        }

        // Specific file types should be handled as external links
        if (/\.(html|php|exe|AppImage)/.test(href)) {
          return `<a href="https://appdb.to/${href}" target="_blank" rel="noopener">${text}</a>`;
        }

        // Email links should remain as is
        if (/^mailto/.test(href)) {
          return match;
        }

        // Internal links should use router-link
        if (this.isInternalLink(href)) {
          return `<router-link to="${href}"${attrs}>${text}</router-link>`;
        }

        return match;
      });
    },
  },
};
</script>
